import { hooks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackWidgetAdded = () => {
  hooks.operations.subscribe(
    hooks.availableHooks.ON_AFTER_BLOCK_ADDED,
    ({ blockId, variationId: blockVariationId, targetBlockId, targetBlockVariationId }) => {
      if (!blockId) return;

      const isBlockWidget = blockId.startsWith('widget-');
      if (!isBlockWidget) return;

      trackEvent(constants.events.WIDGET_ADDED, {
        blockId,
        blockVariationId,
        targetBlockId,
        targetBlockVariationId,
      });
    }
  );
};

export default trackWidgetAdded;
